<script setup lang="ts">
import { NAlert, NButton } from 'naive-ui'

// Retryable error state for the admin queue routes. /lint,
// /synthesis and /usage all rendered a bare red <div> with the raw
// error string and no way to recover short of a full reload. This
// gives them the NAlert styling the sidebar already uses plus a Retry
// button that re-runs the view's fetch. `message` is the store's
// loadError; `retry` is wired to the same fetch the view runs on mount.

defineProps<{ message: string }>()
defineEmits<{ retry: [] }>()
</script>

<template>
  <NAlert type="error" title="Couldn't load this queue" class="my-2" data-testid="queue-error">
    <p class="m-0 mb-2 text-sm">{{ message }}</p>
    <NButton size="small" data-testid="queue-retry" @click="$emit('retry')">Retry</NButton>
  </NAlert>
</template>
